import { render, staticRenderFns } from "./LoanAddPage.vue?vue&type=template&id=3fe7fe98&scoped=true&"
import script from "./LoanAddPage.vue?vue&type=script&lang=js&"
export * from "./LoanAddPage.vue?vue&type=script&lang=js&"
import style0 from "./LoanAddPage.vue?vue&type=style&index=0&id=3fe7fe98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe7fe98",
  null
  
)

export default component.exports